<template>
	<div id="app" role="main">
		<a @click="scrollToMainContent" href="main-content" id="skip-main"
			>Skip to main content</a
		>
		<logo-line></logo-line>
		<alerts></alerts>
		<div id="content">
			<router-view />
		</div>
    <footer class="page-footer font-small pt-4 mt-4">
      <div class=container-row>
        <div class="footer-copyright py-3 text-center">
          <small>© {{ new Date().getFullYear() }} Copyright: <a style="color: #004ea2;" href=https://www.maine.edu>University of
            Maine System</a></small>
        </div>
      </div>
    </footer>
	</div>
</template>

<script>
import LogoLine from "@/components/LogoLine";
import Alerts from "@/components/alerts/index";

export default {
	name: "App",
	components: {
		LogoLine,
		Alerts
	},
	methods: {
		scrollToMainContent(evt) {
			evt.preventDefault();
			document.getElementById("main-content").scrollIntoView();
		}
	}
};
</script>

<style lang="scss">
$primary: #004ea2;
$danger: #800000;

@import "../node_modules/bootstrap/scss/bootstrap";
@import "../node_modules/bootstrap-vue/dist/bootstrap-vue.css";

#app {
	font-family: "Avenir", Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
	max-width: 960px;
	margin: 0 auto;
}

@media only screen and (max-width: 700px) {
	#app {
		padding: 10px;
	}
}

#content {
	/*max-width: 600px;*/
	margin: 0 auto;
}
legend {
	font-weight: bold;
}

.hidden {
	display: none;
}

.whoAmIOptions {
	max-width: 800px !important;
	margin: 0 auto;
}

a#skip-main {
	left: -999px;
	position: absolute;
	top: auto;
	width: 1px;
	height: 1px;
	overflow: hidden;
	z-index: -999;
}

a#skip-main:focus,
a#skip-main:active {
	color: #fff;
	background-color: #000;
	left: auto;
	top: auto;
	width: 30%;
	height: auto;
	overflow: auto;
	margin: 10px 35%;
	padding: 5px;
	border-radius: 15px;
	border: 4px solid yellow;
	text-align: center;
	font-size: 1.2em;
	z-index: 999;
}
</style>
